export default [
  {
    path: '/orders',
    name: 'orders.index',
    component: () => import('@/views/Orders/Index'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/orders/:id/edit',
    name: 'orders.edit',
    component: () => import('@/views/Orders/Edit'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/my-account',
    name: 'my-account.index',
    component: () => import('@/views/Home/Account'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/my-account/notifications',
    name: 'my-account.notifications',
    component: () => import('@/views/Home/NotificationSettings'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/profile',
    name: 'profile.index',
    component: () => import('@/views/Profile/Index'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/promocodes',
    name: 'promocodes.index',
    component: () => import('@/views/Promocodes/Index'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/invoices',
    name: 'invoices.index',
    component: () => import('@/views/Invoices/Index'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/ratings',
    name: 'ratings.index',
    component: () => import('@/views/Ratings/Index'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  // {
  //   path: '/purchases',
  //   name: 'purchases.index',
  //   component: () => import('@/views/Purchases/Index'),
  //   meta: {
  //     perimeter: 'AuthPerimeter',
  //   },
  // },

  {
    path: '/purchases/:id/edit',
    name: 'purchases.edit',
    component: () => import('@/views/Purchases/Edit'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/my-tour-plans',
    name: 'tour-plans.index',
    component: () => import('@/views/TourPlans/Index'),
    meta: {
      perimeter: 'DriverPerimeter',
    },
  },

  {
    path: '/my-tour-plans/:id',
    name: 'tour-plans.view',
    component: () => import('@/views/TourPlans/View'),
    meta: {
      perimeter: 'DriverPerimeter',
    },
  },

  {
    path: '/cooking-support',
    name: 'cooking-support.index',
    component: () => import('@/views/CookingSupport/Index'),
    meta: {
      perimeter: 'KitchenPerimeter',
    },
  },

  {
    path: '/cooking-support/:article_id/:order_form_id',
    name: 'cooking-support.view',
    component: () => import('@/views/CookingSupport/View'),
    meta: {
      perimeter: 'KitchenPerimeter',
    },
  },

  {
    path: '/work-times',
    name: 'work-times.index',
    component: () => import('@/views/WorkTimes/Index'),
    meta: {
      perimeter: 'EmployeePerimeter',
    },
  },

  // {
  //   path: '/work-times/create',
  //   name: 'work-times.create',
  //   component: () => import('@/views/WorkTimes/Create'),
  //   meta: {
  //     perimeter: 'EmployeePerimeter',
  //   },
  // },
  //
  // {
  //   path: '/work-times/:id',
  //   name: 'work-times.edit',
  //   component: () => import('@/views/WorkTimes/Edit'),
  //   meta: {
  //     perimeter: 'EmployeePerimeter',
  //   },
  // },

  {
    path: '/trip-reports',
    name: 'trip-reports.index',
    component: () => import('@/views/TripReports/Index'),
    meta: {
      perimeter: 'DriverPerimeter',
    },
  },

  {
    path: '/trip-reports/create',
    name: 'trip-reports.create',
    component: () => import('@/views/TripReports/Create'),
    meta: {
      perimeter: 'DriverPerimeter',
    },
  },

  {
    path: '/trip-reports/:id',
    name: 'trip-reports.edit',
    component: () => import('@/views/TripReports/Edit'),
    meta: {
      perimeter: 'DriverPerimeter',
    },
  },
];



// WEBPACK FOOTER //
// ./src/routes/auth.js